export default __webpack_public_path__ + "static/media/close-outline.610757e0.svg";